import React, { useEffect } from "react";

const Script = ({ url, async = true, defer = false, injectInHead = true, WrapComponent = null }) => {
  useEffect(() => {
    if (injectInHead && !WrapComponent) {
      const script = document.createElement("script");
      script.src = url;
      script.async = async;
      script.defer = defer;
      document.head.appendChild(script);
    }
  }, [url, async, injectInHead, WrapComponent, defer]);

  let component = url && (!injectInHead || WrapComponent) ? <script src={url} async={async} defer={defer} /> : null;
  if (component && WrapComponent) {
    component = <WrapComponent>{component}</WrapComponent>;
  }
  return component;
};

export default Script;
